/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaidType {
    HOURLY = 'Hourly',
    SALARY = 'Salary',
    OTHER = 'Other',
}
